// extracted by mini-css-extract-plugin
export default {"dashboard_wrap":"Dashboard_dashboard_wrap__b7BD2","title":"Dashboard_title__b7sUx","date_selection":"Dashboard_date_selection__xnkBJ"};